import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import Vuesax from 'vuesax'
import 'material-icons/iconfont/material-icons.css';
import './assets/style.css';
import 'vuesax/dist/vuesax.css' //Vuesax styles
Vue.use(Vuesax, {
  // options here
  // rtl:true
})


import VuePlyr from 'vue-plyr'
import 'vue-plyr/dist/vue-plyr.css'
Vue.use(VuePlyr, {
  plyr: {}
});

import VueMeta from 'vue-meta'
 
Vue.use(VueMeta, {
  // optional pluginOptions
  refreshOnceOnNavigation: true
})

    // Object.defineProperty(Vue.prototype, '$playerOplayer', { value: VuePlyr });


    let ip = "https://www.mtess.gov.dz/ijra-at/"
    Object.defineProperty(Vue.prototype, '$ip', { value: ip });


Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
